/* @flow */
/*jshint esversion: 6 */
import React from "react";
import ReactDOM from "react-dom";
import { Menu, Icon, Badge } from "antd";
import { withRouter } from "react-router-dom";
import TableIDs from "../data/TableIDs";
import LangContext from "../contextProvider/LangContext"

const SubMenu = Menu.SubMenu;

type History = {
    push: Function,
    location: {
        pathname: string
    }
};

type Props = {
    history: History,
    baseUrl: string
};

type State = {
    menuTag: any,
    menuItemsTop: Array<Object>,
    menuItemsDrop: Array<Object>
};

class ReportMenu extends React.Component<Props, State> {
    myHistory: History;
    baseUrl: string;

    constructor(props: Props) {
        super(props);
        this.myHistory = this.props.history;
        this.baseUrl = this.props.baseUrl;

        if (props.data[TableIDs.pseudoSelectorUIcomponentsModules] === undefined) {
            props.data[TableIDs.pseudoSelectorUIcomponentsModules] = { ...props.data.genericSelector };
        }

        this.state = {
            menuTag: (<div></div>),
            menuItemsTop: [
                { KeyComp: "51", key: "sales-compare", text: "השוואת מסמכים", keyLang: 10197, icon: "setting" },
                //{ KeyComp: "0", key: "hour-report", text: "דוח שעות", icon: "setting" },
                { KeyComp: "177", key: "bi-targets", text: "יעדים למודול BI", keyLang: 20887, icon: "sync" },
                { KeyComp: "52", key: "sales-by-date", text: "מכירות - לתקופה", keyLang: 10198, icon: "setting" },
                { KeyComp: "53", key: "sales-avg", text: "מכירות - ממוצע", keyLang: 10199, icon: "setting" },
                { KeyComp: "54", key: "sales-profit", text: "מכירות - רווח", keyLang: 10200, icon: "setting" },
                { KeyComp: "55", key: "sales-detailed", text: "מכירות - מפורט", keyLang: 10201, icon: "setting" },
                { KeyComp: "56", key: "sales-matrix", text: "מכירות - פרטי מטריצה", keyLang: 10202, icon: "setting" },
                { KeyComp: "57", key: "sales-days-hours", text: "מכירות - לפי ימים או שעות", keyLang: 13977, icon: "setting" },
                { KeyComp: "58", key: "sales-store-visits", text: "דוח ביקורים בחנות", keyLang: 14171, icon: "shop" },
                { KeyComp: "59", key: "sales-analysis-branches", text: 'ניתוח מכירות ריכוזי', keyLang: 14571, icon: "bar-chart" },
                { KeyComp: "60", key: "sales-analysis", text: 'ניתוח מכירות תקופתי', keyLang: 14559, icon: "bar-chart" },
                { KeyComp: "171", key: "sales-discounts", text: 'דו"ח הנחות', keyLang: 14640, icon: "percentage" },
                { KeyComp: "172", key: "profit-expanded", text: "דוח רווח מורחב", keyLang: 16488, icon: "file" },
                { KeyComp: "173", key: "tax-report", text: 'דו"ח מע"מ', keyLang: 17446, icon: "audit" },
                { KeyComp: "174", key: "customer-monthly", text: "לקוחות חודשי", keyLang: 17515, icon: "team" },
                { KeyComp: "175", key: "excel-tags-branches", text: "אקסל ניתוח תגיות לפי סניפים", keyLang: 18365, icon: "file-excel" },
                { KeyComp: "176", key: "item-analysis", text: "דוח ניתוח פריט", keyLang: 20170, icon: "sliders" },
                { KeyComp: "178", key: "sales-excel", text: "הפקת אקסל מכירות לתאריך", keyLang: 21305, icon: "file-excel" },
                { KeyComp: "179", key: "dynamic-sales-display", text: "תצוגת מכירות דינמית", keyLang: 21315, icon: "area-chart" },
                { KeyComp: "180", key: "daily-sales-and-receipts-excel", text: "אקסל מכירות ותקבולים לפי ימים", keyLang: 22453, icon: "file-excel" },
                { KeyComp: "292", key: "sales-branches-excel", text: "אקסל מכירות מרוכז לפי סניף", keyLang: 22603, icon: "file-excel" },
            ].filter((menuItem, index) => this.isActive(menuItem.KeyComp)),
            menuItemsDrop: []
        };
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    isActive = (key) => {
        return this.props.data[TableIDs.pseudoSelectorUIcomponentsModules].dataset
            .map(obj => obj.code).includes(key);
    };

    onMenuSelect(args) {
        this.myHistory.push(
            this.baseUrl + "/reports_sales/" + (args.key !== "home" ? args.key : ""),
            {}
        );
    }

    updatePriorityMenu = () => {
        let maxHeight = 50; //px
        let _height = -1;
        let firstIter = true;

        let listTop = this.state.menuItemsTop;
        let listDrop = this.state.menuItemsDrop;
        // re-populate menu
        for (let i = 0; i < listDrop.length; i++) {
            listTop.push(listDrop.pop());
        }

        //ReactDOM.findDOMNode(this).clientHeight;
        while (_height > maxHeight || _height < 0) {
            //this.state.menuItemsDrop.push(this.state.menuItemsTop.pop());
            if (!firstIter) {
                this.state.menuItemsDrop.push(this.state.menuItemsTop.pop());
            }
            else {
                firstIter = false;
            }
            this.setState((prevState, props) => {
                return {
                    menuTag: <Menu
                        mode="horizontal"
                        defaultSelectedKeys={[
                            this.myHistory.location.pathname.split(this.baseUrl).join("").split("/")[2] || "home"
                        ]}
                        onSelect={this.onMenuSelect.bind(this)}
                    >
                        {this.renderMenuItemsTop()}
                        <SubMenu title={<Badge count={listDrop.length}>
                            <span><Icon type="ellipsis" /></span></Badge>}>
                            {this.renderMenuItemsDrop()}
                        </SubMenu>
                    </Menu>
                }
            });
            console.log("findDomNode sales: ", (this) ? "true" : "false", this);
            let e: Element | null | Text = ReactDOM.findDOMNode(this);
            _height = (e instanceof HTMLElement) ? e.clientHeight : 0;
            //alert(_height);
        }
    }

    renderMenuItemsTop() {
        let res = [];
        let list = this.state.menuItemsTop;
        if (list.length > 0) {
            for (let item of list) {
                res.push(
                    <Menu.Item key={item.key}>
                        <Icon type={item.icon} className="menu-icon" />
                        <span>{item.keyLang ? this.getText(item.keyLang) : ""}</span>
                    </Menu.Item>);
            }
            return res;
        }
    }

    renderMenuItemsDrop() {
        let res = [];
        let list = this.state.menuItemsDrop;
        if (list.length > 0) {
            for (let item of list) {
                res.push(
                    <Menu.Item key={item.key}>
                        <Icon type={item.icon} className="menu-icon" />
                        <span>{item.keyLang ? this.getText(item.keyLang) : ""}</span>
                    </Menu.Item>);
            }
        }
        return res;
    }

    doUpdateOfPriorityMenu = () => {
        setTimeout(this.updatePriorityMenu);
    };

    // Add event listener
    componentDidMount() {
        setTimeout(this.updatePriorityMenu);
        //window.addEventListener("resize", this.updatePriorityMenu);
        window.addEventListener("resize", this.doUpdateOfPriorityMenu);
    }

    // Remove event listener
    componentWillUnmount() {
        //window.removeEventListener("resize", this.updatePriorityMenu);
        window.removeEventListener("resize", this.doUpdateOfPriorityMenu);
    }

    render() {
        return this.state.menuTag;
    }
}

export default withRouter(ReportMenu);
